<div class="_expand z-1"
     (offClick)="toggleVisibility(false)"
     [offClickOff]="!isVisible"
     [offClickFilter]="'[pageHeaderMeganavSearchOutlet]'">
    <!-- close -->
    <div class="_overlay bg-col-w z-1 height-100">

    </div>

    <div class="_overlay fill z-2 bg-col-6"
         style="box-shadow: 0 0 4px 0 rgba(33, 33, 33, 0.15)">
        <div class="wrap height-100">
            <div class="center pos-relative height-100">
                <i class="icon-close cursor-pointer _close"
                   (click)="toggleVisibility(false)"></i>
                <div class="c-6 m-r-0 m-b-0 height-100">
                    <div class="flex flex-middle height-100 flex-justify-start">
                        <div class="w-12 flex flex-justify-start bg-col-51 p-a-3 p-l-4 p-r-4 b-radius-4">
                            <button [iconButton]
                                    [status]="status"
                                    cy-searchbutton
                                    #iconOn
                                    (click)="goToSearchView()"
                                    aria-label="Search"
                                    [icon]="'search'"></button>
                            <input type="text"
                                   cy-searchInput
                                   [(ngModel)]="term"
                                   (keyup)="onInputKeyUp($event)"
                                   (focus)="onInputFocus()"
                                   class="flex-grow m-l-2 _input"
                                   #input
                                   [placeholder]="'What are you looking for?' | translate">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="right pos-relative z-2 inline-block _iconOff w-12"
     #iconOff>
    <button (click)="input.focus()"
            aria-hidden="true"
            class="w-12 flex flex-middle bg-col-51 p-a-3 p-l-4 p-r-4 b-radius-4">
        <i class="_placeholderIcon search-icon icon-search cursor-pointer"
           aria-hidden="true"></i>
        <p class="p1 col-4 p-l-3">
            {{'Search for a product' | translate}}
        </p>
    </button>
</div>
